// client/src/pages/dashboard-v2/components/TotalInfo.js
import React, { useState, useEffect } from 'react';
import axios from "axios";

export default function TotalInfo() {
  const [inv, setInv] = useState({
    cardTotalCost: 0,
    cardFeeGrade: 0,
    cardFeeShipTax: 0,
    cardPrice: 0,
    inventoryCount: 0,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [cost, grade, shipTax, price, count] = await Promise.all([
          axios.get("https://api.alientrader.cards/reports/card_total_cost"),
          axios.get("https://api.alientrader.cards/reports/card_fee_grade"),
          axios.get("https://api.alientrader.cards/reports/card_fee_shiptax"),
          axios.get("https://api.alientrader.cards/reports/card_price"),
          axios.get("https://api.alientrader.cards/reports/inventory_count"),
        ]);

        setInv({
          cardTotalCost: cost.data[0].CardTotalCost,
          cardFeeGrade: grade.data[0].CardFeeGrade,
          cardFeeShipTax: shipTax.data[0].CardFeeShipTax,
          cardPrice: price.data[0].CardPrice,
          inventoryCount: count.data[0].InventoryCount,
        });
      } catch (err) {
        console.error("API Fetch Error:", err);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="info-grid">
      <span className="k">Total Cards:</span>
      <span className="v">{inv.inventoryCount.toLocaleString()}</span>

      <span className="k">Total Cost:</span>
      <span className="v">{fmt(inv.cardTotalCost)}</span>

      <span className="k">Cost:</span>
      <span className="v">{fmt(inv.cardPrice)}</span>

      <span className="k">Grading Fees:</span>
      <span className="v">{fmt(inv.cardFeeGrade)}</span>

      <span className="k">Shipping & Tax Fees:</span>
      <span className="v">{fmt(inv.cardFeeShipTax)}</span>
    </div>
  );
}

function fmt(n){ return n.toLocaleString("en-US",{style:"currency",currency:"USD"}); }
